{
  "common": {
    "button": {
      "continue": "Продолжить",
      "back": "Назад",
      "cancel": "Отмена",
      "save": "Сохранить",
      "confirm": "Подтвердить",
      "send": "Отправить",
      "edit": "Редактировать",
      "delete": "Удалить",
      "add": "Добавить",
      "close": "Закрыть",
      "apply": "Применить",
      "reset": "Сбросить",
      "login": "Войти",
      "register": "Зарегистрироваться",
      "logout": "Выйти",
      "tryAgain": "Попробовать снова",
      "upload": "Загрузить",
      "change": "Изменить",
      "select": "Выбрать"
    },
    "validation": {
      "required": "Поле обязательно для заполнения",
      "email": "Введите корректный email",
      "minLength": "Минимальная длина — {{ min }} символов",
      "maxLength": "Максимальная длина — {{ max }} символов",
      "pattern": "Неверный формат",
      "phone": "Введите корректный номер телефона",
      "passwordMismatch": "Пароли не совпадают",
      "passwordStrength": "Пароль должен содержать буквы и цифры",
      "inn": "ИНН должен содержать 10 или 12 цифр",
      "otp": "Введите все цифры кода"
    },
    "error": {
      "unknown": "Что-то пошло не так. Попробуйте ещё раз",
      "network": "Ошибка соединения. Проверьте интернет",
      "notFound": "Не найдено",
      "unauthorized": "Нет доступа"
    },
    "placeholder": {
      "search": "Поиск...",
      "notSelected": "Не выбрано"
    },
    "status": {
      "approved": "Одобрено",
      "pending": "На рассмотрении",
      "rejected": "Отклонено"
    },
    "countdown": {
      "days": "Дней",
      "hours": "Часов",
      "minutes": "Минут",
      "seconds": "Секунд"
    }
  },
  "auth": {
    "login": {
      "greeting": "Здравствуйте! 👋",
      "subtitle": "Для входа и регистрации понадобится только ваш номер телефона и пароль",
      "backBtn": "Вернуться назад",
      "phone": "Номер телефона",
      "password": "Пароль",
      "forgotPassword": "Забыли пароль?",
      "submit": "Войти в аккаунт",
      "noAccount": "Нет аккаунта?",
      "register": "Пройти регистрацию",
      "guestMode": "Продолжить в гостевом режиме",
      "error": {
        "invalid": "Неверный номер телефона или пароль"
      }
    },
    "forgotPassword": {
      "phoneStep": {
        "title": "Восстановление пароля",
        "subtitle": "Введите номер телефона, привязанный к аккаунту",
        "phoneLabel": "Номер телефона",
        "submit": "Получить код",
        "backToLogin": "Вернуться ко входу"
      },
      "codeStep": {
        "title": "Введите код из SMS",
        "sentTo": "Мы выслали код на номер:",
        "resend": "Отправить новый код",
        "error": "Неверный код. Попробуйте ещё раз"
      },
      "newPassword": {
        "title": "Новый пароль",
        "subtitle": "Придумайте надёжный пароль для вашего аккаунта",
        "passwordLabel": "Новый пароль",
        "passwordPlaceholder": "Введите новый пароль",
        "confirmLabel": "Подтвердите пароль",
        "confirmPlaceholder": "Повторите пароль",
        "hint": "Минимум 8 символов: буквы и цифры",
        "submit": "Сохранить пароль",
        "success": {
          "title": "Пароль изменён",
          "message": "Вы можете войти в аккаунт с новым паролем",
          "button": "Войти"
        }
      }
    },
    "createPassword": {
      "title": "Создание пароля",
      "subtitle": "Придумайте надёжный пароль для вашего аккаунта",
      "password": "Новый пароль",
      "passwordPlaceholder": "Введите пароль",
      "confirmPassword": "Подтвердите пароль",
      "confirmPlaceholder": "Повторите пароль",
      "submit": "Сохранить пароль",
      "hint": "Минимум 8 символов, буквы и цифры"
    },
    "register": {
      "title": "Регистрация",
      "steps": {
        "account": "Аккаунт",
        "shop": "Магазин",
        "store": "Склад",
        "phone": "Подтверждение"
      },
      "step": "Этап {{ current }}/{{ total }} - {{ title }}",
      "account": {
        "title": "Создание аккаунта",
        "subtitle": "Заполните данные для регистрации",
        "name": "Имя",
        "namePlaceholder": "Введите имя",
        "surname": "Фамилия",
        "surnamePlaceholder": "Введите фамилию",
        "email": "Email",
        "emailPlaceholder": "Введите email",
        "phone": "Номер телефона",
        "phonePlaceholder": "+7 (___) ___-__-__",
        "password": "Пароль",
        "passwordPlaceholder": "Придумайте пароль",
        "confirmPassword": "Подтвердите пароль",
        "confirmPlaceholder": "Повторите пароль",
        "agreeTerms": "Я принимаю",
        "terms": "условия использования",
        "and": "и",
        "privacy": "политику конфиденциальности",
        "submit": "Продолжить",
        "alreadyHaveAccount": "Уже есть аккаунт?",
        "login": "Войти",
        "error": {
          "emailExists": "Аккаунт с таким email уже существует",
          "phoneExists": "Аккаунт с таким номером уже существует"
        }
      },
      "store": {
        "title": "Выберите склад",
        "subtitle": "Выберите склад для хранения и доставки ваших товаров",
        "stepTitle": "Выбор склада",
        "filter": "Фильтр",
        "noResults": "Нет доступных складов",
        "loadError": "Не удалось загрузить список складов",
        "atLeastOne": "Выберите хотя бы один склад",
        "select": "Выбрать",
        "selected": "Выбрано",
        "detail": {
          "back": "Назад к списку складов",
          "conditions": "Условия доставки",
          "description": "Описание"
        },
        "submit": "Отправить запрос",
        "success": {
          "title": "Запрос отправлен!",
          "message": "Ваша заявка на регистрацию магазина была успешно отправлена. Наша команда рассмотрит её в течение 24 часов.",
          "button": "На главную"
        }
      },
      "phone": {
        "title": "Подтверждение телефона",
        "subtitle": "Введите код из SMS, отправленного на номер",
        "codeLength": "6",
        "resend": "Отправить повторно",
        "resendIn": "Повторная отправка через {{ seconds }} сек.",
        "submit": "Подтвердить",
        "success": "Телефон подтверждён",
        "error": {
          "invalid": "Неверный код подтверждения",
          "expired": "Код истёк. Запросите новый"
        }
      },
      "phoneStep": {
        "stepTitle": "Ваш номер",
        "title": "Регистрация",
        "subtitle": "Для регистрации нам понадобится только ваш номер телефона",
        "phoneLabel": "Номер телефона",
        "termsPrefix": "Нажимая кнопку \"Отправить код\" - вы принимаете",
        "termsLink1": "Условия использования сайта",
        "termsMid": "соглашаетесь на обработку персональных данных в соответствии с",
        "termsLink2": "Политикой обработки персональных данных",
        "submit": "Отправить код",
        "termsRequired": "Для продолжения необходимо дать согласие на обработку персональных данных"
      },
      "codeStep": {
        "stepTitle": "Код из SMS",
        "title": "Введите код из SMS",
        "sentTo": "Мы выслали код для входа на номер:",
        "resend": "Отправить новый код",
        "error": "Неверный код, попробуйте ещё раз"
      },
      "accountInfo": {
        "stepTitle": "Общая информация",
        "title": "Общая информация",
        "subtitle": "Заполните информацию, чтобы завершить процесс регистрации",
        "firstName": "Имя",
        "firstNamePlaceholder": "Ваше имя",
        "lastName": "Фамилия",
        "lastNamePlaceholder": "Ваша фамилия",
        "middleName": "Отчество",
        "middleNamePlaceholder": "Ваше отчество",
        "gender": "Пол",
        "genderPlaceholder": "Выбрать пол",
        "genderMale": "Мужской",
        "genderFemale": "Женский",
        "buyerType": "Тип пользователя",
        "buyerTypePlaceholder": "Выбрать тип",
        "buyerTypeWholesale": "Оптовый",
        "buyerTypeRetail": "Розничный",
        "email": "Эл почта",
        "emailPlaceholder": "Ваша почта",
        "country": "Страна",
        "countryPlaceholder": "Выбрать страну",
        "city": "Город",
        "cityPlaceholder": "Указать город",
        "submit": "Перейти к следующему этапу"
      },
      "shop": {
        "title": "Создание магазина",
        "subtitle": "Для совершения заказов необходимо зарегистрировать свой магазин",
        "stepTitle": "Создание магазина",
        "country": "Страна",
        "countryPlaceholder": "Выбрать страну",
        "address": "Адрес",
        "addressPlaceholder": "Указать адрес",
        "addressDialogTitle": "Укажите адрес магазина",
        "contractorType": "Тип контрагента",
        "contractorTypePlaceholder": "Выбрать тип",
        "contractorTypeEntity": "Юридическое лицо",
        "contractorTypeIndividual": "Физическое лицо",
        "contractorTypeIE": "Индивидуальный предприниматель",
        "contractorName": "Наименование контрагента",
        "contractorNamePlaceholder": "Наименование",
        "inn": "ИНН",
        "innPlaceholder": "Ваш ИНН",
        "shopName": "Название магазина",
        "shopNamePlaceholder": "Название",
        "submit": "Перейти к следующему этапу"
      },
      "password": {
        "title": "Регистрация",
        "subtitle": "Заполните информацию, чтобы завершить процесс регистрации",
        "passwordLabel": "Пароль",
        "passwordPlaceholder": "Ваш пароль",
        "confirmLabel": "Повторите пароль",
        "confirmPlaceholder": "Повторите ваш пароль",
        "hint": "Минимум 8 символов, буквы и цифры",
        "submit": "Перейти к следующему этапу",
        "stepTitle": "Пароль"
      }
    }
  },
  "orders": {
    "title": "Заказы",
    "empty": "Заказов пока нет",
    "card": {
      "title": "Заказ №{{ id }}",
      "shop": "Магазин",
      "store": "Склад"
    },
    "status": {
      "approved": "Одобрен",
      "declined": "Отклонён",
      "partial": "Частично одобрен",
      "pending": "На рассмотрении"
    },
    "detail": {
      "back": "Назад к заказам",
      "title": "Заказ №{{ id }}",
      "info-heading": "Информация о заказе",
      "items": "Состав заказа",
      "empty": "Позиций нет",
      "contact": "Отследить доставку",
      "delivery-date": "Дата поставки",
      "shop": "Магазин",
      "store": "Склад",
      "created": "Создан"
    }
  },
  "acts": {
    "title": "Акты сверки",
    "empty": "Актов сверки пока нет",
    "card": {
      "title": "Акт-сверки №{{ number }}"
    },
    "info": {
      "title": "Акт сверки взаиморасчётов",
      "desc1": "Акт сверки взаиморасчётов — документ, который составляют две компании, чтобы согласовать платежи и понять, должен ли кто-то кому-то.",
      "desc2": "Для запроса укажите период. Ответ придёт на вашу электронную почту, которая указана в настройках.",
      "create": "Создать акт сверки"
    },
    "sort": {
      "startDate": "Дата начала",
      "endDate": "Дата конца",
      "desc": "По убыванию",
      "asc": "По возрастанию"
    },
    "create": {
      "title": "Новый акт-сверки",
      "shop": "Магазин",
      "shopPlaceholder": "Выбрать магазин",
      "warehouse": "Склад",
      "warehousePlaceholder": "Выбрать склад",
      "email": "Электронная почта",
      "emailPlaceholder": "Ваш адрес",
      "startDate": "От",
      "endDate": "До",
      "datePlaceholder": "Выбрать дату",
      "submit": "Отправить запрос",
      "submitPage": "Перейти к следующему этапу"
    },
    "delete": {
      "title": "Удалить акт сверки?",
      "message": "Это действие нельзя отменить."
    }
  },
  "claims": {
    "title": "Рекламации",
    "empty": "Рекламаций пока нет",
    "card": {
      "title": "Рекламация №{{ number }}"
    },
    "status": {
      "approved": "Заявка одобрена",
      "declined": "Заявка отклонена",
      "pending": "Заявка на рассмотрении",
      "partial": "Заявка частично одобрена"
    },
    "sort": {
      "created": "Дата создания",
      "deliveryTime": "Дата поставки",
      "sum": "Сумма",
      "desc": "По убыванию",
      "asc": "По возрастанию"
    },
    "info": {
      "title": "Рекламация",
      "desc": "Это претензия покупателя или заказчика, предъявляемая продавцу или поставщику (подрядчику) по поводу ненадлежащего качества или количества поставляемого товара",
      "rules": "Правила подачи",
      "add": "Добавить"
    },
    "delete": {
      "title": "Удалить рекламацию?",
      "message": "Это действие нельзя отменить."
    },
    "rules": {
      "title": "Правила подачи",
      "rule1": "1. Рекламация на бракованный (испорченный, потерявший свои основные свойства) товар принимается в течение суток с момента покупки товара в нашем цветочном центре, либо с момента получения товара путем доставки нашим специализированным транспортом.",
      "rule2": "2. Рекламация принимается в виде фотографий (формат jpg, jpeg, png), где должны быть четко видны все моменты, которые могут подтвердить ненадлежащее качество товара. Что касается срезанных цветов, то рекламация принимается на товар, который ни коем образом не может быть вами использован (цветы, утратившие свои основные свойства).",
      "rule2note": "Выставляя рекламацию на срезанные цветы, пожалуйста, фотографируйте товар ВМЕСТЕ С ЕГО ФИРМЕННОЙ УПАКОВКОЙ. Так же обязательно прикладывайте фотографию, где отчетливо виден штрих-код, наклеенный на упаковку. Если на упаковке несколько штрих-кодов, то фотографируйте все.",
      "rule3": "3. При написании рекламации на срезанные цветы необходимо сделать такие фотографии, на которых можно однозначно и четко посчитать количество бракованной продукции (в стеблях).",
      "rule4": "4. Рекламация НЕ принимается в том случае, когда количество бракованной продукции не превышает 3% от общего количества купленной продукции данного типа.",
      "example": {
        "title": "Например",
        "item1": "купили 250 роз Эквадор (10 пачек). Оказалось 5шт бракованных - 2% от общего количества. Рекламация НЕ принимается.",
        "item2": "купили 1500 роз Эквадор (60 пачек). Оказалось 100 шт бракованных - 6,66%. Рекламация ПРИНИМАЕТСЯ."
      }
    },
    "detail": {
      "title": "Рекламация №{{ id }}",
      "created": "Создана",
      "claimDate": "Дата рекламации",
      "shop": "Магазин",
      "store": "Склад",
      "moderatorComment": "Комментарий модератора",
      "infoHeading": "Информация о рекламации",
      "contactData": "Контактные данные:",
      "phone": "Номер телефона",
      "email": "Эл. Почта",
      "photos": "Фотографии:",
      "claimDetails": "Описание рекламации:",
      "claimSum": "Сумма претензии",
      "deliveryDate": "Дата поставки",
      "invoiceNumber": "Номер накладно",
      "description": "Описание повреждений"
    },
    "create": {
      "title": "Новая рекламация",
      "subtitle": "Заполните информацию, чтобы отправить запрос",
      "shop": "Магазин",
      "shopPlaceholder": "Выберите магазин",
      "store": "Склад",
      "storePlaceholder": "Выберите склад",
      "email": "Электронная почта",
      "emailPlaceholder": "example@mail.ru",
      "deliveryTime": "Дата доставки",
      "datePlaceholder": "дд.мм.гггг",
      "claimSum": "Сумма претензии",
      "claimSumPlaceholder": "0.00",
      "contactNumber": "Номер телефона",
      "invoiceNumber": "Номер накладной",
      "invoiceNumberPlaceholder": "Введите номер накладной",
      "description": "Описание",
      "descriptionPlaceholder": "Опишите причину рекламации (до 2500 символов)",
      "photos": "Добавить фото",
      "addPhoto": "Добавить фото",
      "submit": "Отправить запрос",
      "imagesRequired": "Необходимо добавить хотя бы одно фото"
    }
  },
  "documents": {
    "title": "Документы",
    "subtitle": "Выберите склад для просмотра документации",
    "empty": "Склады не найдены",
    "noDocuments": "Документы не найдены"
  },
  "profile": {
    "personalInfo": {
      "title": "Персональная информация",
      "changeAvatar": "Изменить фото профиля",
      "save": "Сохранить изменения",
      "firstName": "Имя",
      "firstNamePlaceholder": "Введите имя",
      "lastName": "Фамилия",
      "lastNamePlaceholder": "Введите фамилию",
      "middleName": "Отчество",
      "middleNamePlaceholder": "Введите отчество",
      "gender": "Пол",
      "buyerType": "Тип покупателя",
      "country": "Страна",
      "city": "Город",
      "email": "Электронная почта",
      "emailPlaceholder": "example@mail.ru"
    },
    "changePassword": {
      "title": "Изменение пароля",
      "save": "Сохранить изменения",
      "current": "Текущий пароль",
      "new": "Новый пароль",
      "confirm": "Повтор нового пароля",
      "placeholder": "Пароль"
    },
    "support": {
      "title": "Остались вопросы?",
      "desc": "Задайте интересующий вопрос нашей техподдержке в чате!",
      "button": "Открыть чат с поддержкой →"
    },
    "promo": {
      "title": "Откройте свой магазин в Клике!",
      "desc": "Клик Маркет — это маркетплейс по продаже цветов, букетов, игрушек, десертов, тортов и подарков. Регистрируйте магазин и зарабатывайте с Кликом!",
      "button": "Открыть свой магазин"
    },
    "deleteAccount": {
      "trigger": "Удалить аккаунт",
      "title": "Удаление аккаунта",
      "warning": "Предупреждение!",
      "warningText1": "Отменить удаление аккаунта невозможно. Аккаунт и все связанные с ним данные будут удалены",
      "warningBullet1": "История заказов, доставок и остальные данные будут потеряны;",
      "warningBullet2": "Текущие заказы будут отменены",
      "reasonPrompt": "Пожалуйста, расскажите нам, почему вы решили удалить аккаунт на Click Business",
      "reasonLabel": "Описание*",
      "cancel": "Отменить",
      "reasonPlaceholder": "Причина удаления",
      "codeHint": "Мы отправили код подтверждения на ваш номер телефона",
      "confirm": "Удалить аккаунт"
    }
  },
  "main": {
    "nav": {
      "feed": "Лента",
      "preorder": "Предзаказ",
      "click": "Click",
      "orders": "Заказы",
      "warehouses": "Склады",
      "chats": "Чаты",
      "myShops": "Мои магазины",
      "acts": "Акты сверки",
      "claims": "Рекламации",
      "documents": "Документы",
      "profile": "Профиль"
    },
    "header": {
      "sellOnMarket": "Продавать на Клик Маркете",
      "notifications": "Уведомления",
      "messages": "Сообщения",
      "profile": "Профиль",
      "menu": "Меню"
    },
    "footer": {
      "description": "Маркетплейс по продаже цветов, букетов, игрушек, десертов, тортов и подарков",
      "mobileApp": "Мобильное приложение",
      "mobileAppSubtitle": "Скачивайте и наслаждайтесь всеми возможностями!",
      "terms": "Условия использования",
      "privacy": "Политика конфиденциальности",
      "copyright": "© Click Business 2025"
    }
  },
  "myShops": {
    "title": "Мои магазины",
    "empty": "У вас пока нет магазинов",
    "sidebar": {
      "title": "Магазины",
      "description": "Для подключения складов и общения с менеджерами и поставщиками необходимо зарегистрировать свой магазин",
      "addButton": "Добавить магазин"
    },
    "contractorType": {
      "ENTITY": "Юридическое лицо",
      "INDIVIDUAL": "Физическое лицо",
      "INDIVIDUAL_ENTREPRENEUR": "Индивидуальный предприниматель"
    },
    "status": {
      "partial": "Частично одобрено"
    },
    "detail": {
      "infoTitle": "Информация о магазине",
      "editShop": "Редактировать магазин",
      "storesTitle": "Подключённые склады",
      "addStore": "Добавить новый склад",
      "storesEmpty": "Нет подключённых складов",
      "fields": {
        "address": "Местоположение",
        "type": "Тип",
        "contractorName": "Наименование",
        "website": "Сайт",
        "itn": "ИНН"
      },
      "description": "Это панель управления вашего магазина, здесь вы сможете настроить информацию о нём",
      "storeStatus": {
        "connected": "Склад подключён",
        "pending": "На рассмотрении",
        "partial": "Частично подключён",
        "disconnected": "Склад не подключён"
      }
    },
    "form": {
      "titleCreate": "Новый магазин",
      "titleEdit": "Редактировать магазин"
    },
    "stores": {
      "titleCreate": "Выбор склада",
      "titleEdit": "Редактировать склады",
      "titleStores": "Добавить склад",
      "listTitle": "Доступные склады",
      "listSubtitle": "Выберите один или несколько складов для вашего магазина",
      "submit": "Сохранить"
    }
  },
  "chats": {
    "headerName": "Click Business",
    "headerSubtitle": "Техподдержка",
    "empty": "Напишите нам — мы на связи",
    "uploadingImage": "Загрузка фото...",
    "uploadingPdf": "Загрузка PDF...",
    "retry": "Отправить повторно?",
    "placeholder": "Ваше сообщение...",
    "today": "Сегодня",
    "yesterday": "Вчера"
  },
  "warehouses": {
    "myStores": "Мои склады",
    "addStore": "+ Добавить новый склад",
    "availableStores": "Доступные склады",
    "allStores": "Все склады",
    "rules": "Правила",
    "connect": "Подключить",
    "details": "Подробнее",
    "declined": "Заявка отклонена — Читать подробнее",
    "pending": "Заявка на подключение в обработке",
    "empty": "Нет доступных складов",
    "contactStore": "Связаться со складом",
    "info": "Информация"
  },
  "notifications": {
    "title": "Уведомления",
    "empty": "Уведомлений нет",
    "loadMore": "Загрузить ещё",
    "delete": "Удалить уведомление"
  },
  "feed": {
    "author": {
      "platformDescription": "✅ 10 лет обучаем флористике офлайн/онлайн\n✅ Стань лучшим в своем городе\n✅ Открой свой Цветочный бизнес вместе\n✅ С нуля до Профи за несколько недель"
    }
  },
  "preorder": {
    "title": "Предзаказ",
    "shop": "Магазин",
    "shopPlaceholder": "Выберите магазин",
    "store": "Склад",
    "storePlaceholder": "Выберите склад",
    "date": "Дата поставки",
    "datePlaceholder": "Выберите дату",
    "selectHint": "Выберите магазин, склад и дату доставки, чтобы увидеть товары",
    "all": "Все",
    "empty": "Товаров не найдено",
    "error": "Не удалось загрузить товары",
    "remains": "Остаток: {{count}} шт.",
    "find": "Найти товары",
    "products": "Товары",
    "searchPlaceholder": "Поиск товаров...",
    "filter": "Фильтрация",
    "delivery": "Доставка",
    "promotions": "Актуальные акции",
    "labels": "Фильтр по меткам",
    "reset": "Сбросить",
    "noLabels": "Для этих товаров нет меток",
    "bought": "Куплено: {{count}} шт.",
    "sortBtn": "Сортировка",
    "apply": "Выбрать",
    "sort": {
      "title": "Сортировать",
      "by": "Сортировать по",
      "order": "Порядок",
      "END_DATE": "Завершению",
      "DELIVERY_DATE": "Поставке",
      "ASC": "Возрастание",
      "DESC": "Убывание"
    },
    "buy": "Купить",
    "dialog": {
      "addToCart": "В корзину",
      "decrease": "Уменьшить количество",
      "increase": "Увеличить количество"
    },
    "basket": {
      "title": "Корзина",
      "date": "Дата предзаказа:",
      "yearSuffix": "года",
      "delivery": "Доставка:",
      "noPrice": "Цена не указана",
      "remove": "Удалить из корзины",
      "clear": "Очистить корзину",
      "clearTitle": "Очистить корзину?",
      "clearMessage": "Все товары будут удалены из корзины.",
      "clearConfirm": "Очистить",
      "submit": "Оформить запрос",
      "empty": "Корзина пуста",
      "back": "Вернуться к товарам",
      "open": "Корзина",
      "error": "Не удалось отправить запрос. Попробуйте ещё раз.",
      "sent": "Запрос отправлен",
      "inBasket": "В корзине: {{count}}",
      "noPricePerUnit": "Цена за шт. не указана"
    },
    "product": {
      "pickCount": "Выберите количество товара:",
      "order": "Заказать"
    },
    "addedToBasket": "Добавлено в корзину"
  },
  "lot": {
    "shop": "Магазин",
    "shopPlaceholder": "Выберите магазин",
    "store": "Склад",
    "storePlaceholder": "Выберите склад",
    "empty": "Товаров не найдено",
    "error": "Не удалось загрузить товары",
    "remains": "Остаток: {{count}} шт.",
    "find": "Найти товары",
    "products": "Товары",
    "searchPlaceholder": "Поиск товаров...",
    "filter": "Фильтрация",
    "delivery": "Доставка",
    "promotions": "Актуальные акции",
    "labels": "Фильтр по меткам",
    "reset": "Сбросить",
    "noLabels": "Для этих товаров нет меток",
    "bought": "Куплено: {{count}} шт.",
    "sortBtn": "Сортировка",
    "apply": "Выбрать",
    "title": "Лоты",
    "selectHint": "Выберите магазин и склад, чтобы увидеть лоты",
    "buyFrom": "Купить от {{price}} ₽ / шт",
    "sort": {
      "title": "Сортировать",
      "by": "Сортировать по",
      "order": "Порядок",
      "PRICE": "Цене",
      "END_DATE": "Завершению",
      "DELIVERY_DATE": "Поставке",
      "ASC": "Возрастание",
      "DESC": "Убывание"
    },
    "buy": "Купить",
    "options": {
      "title": "Выберите объём пакинга:",
      "piece": "шт",
      "pcs": "шт.",
      "benefit": "Выгода {{percent}}%",
      "selected": "Выбрано",
      "selectedBenefit": "Выбрано - Выгода {{percent}}%",
      "addToBasket": "В корзину"
    },
    "addedToBasket": "Добавлено в корзину",
    "basket": {
      "title": "Корзина",
      "open": "Корзина",
      "inBasket": "В корзине",
      "total": "Итого:",
      "remove": "Удалить из корзины",
      "clear": "Очистить корзину",
      "clearTitle": "Очистить корзину?",
      "clearMessage": "Все лоты будут удалены из корзины.",
      "clearConfirm": "Очистить",
      "submit": "Оформить заказ",
      "empty": "Корзина пуста",
      "back": "Вернуться к лотам",
      "error": "Не удалось оформить заказ",
      "sent": "Заказ оформлен"
    }
  }
}
